<template>
 <div class="sidebar">
      <ul>
          <li v-for="(f, i) in menuArr" :key="i">{{f.NAME}}
            <ul>
              <li v-for="e in f.ELEMENTS" :key="e.ID"><a :href="'/project/'+e.ID">{{e.NAME}}</a></li>
            </ul>
          </li>
      </ul>                  
 </div>
</template>

<script>
import axios from 'axios'
const urlMenu = 'https://andreykolesnikov.com/ajax/get_menu.php?iblock=57'
export default {
  name: 'Menu',
  data() {
    return {
      menuArr: [],
      h: 0
    };
  },
  mounted() {
    // axios({
    //   method: 'POST',
    //   url: urlMenu,
    //   headers: {}, 
    //   data: {
    //     code: 'projects',
    //     type: 'services'
    //   }
    // }).then(response => {
    //   this.menuArr = response.data
    //   console.log(this.menuArr);
    // });
    axios.get(urlMenu).then(response => {
      this.menuArr = response.data
      console.log(this.menuArr);
    });
    
  }
}
</script>